import { ListBox, Grid, GridItem } from '@flos/react-ui';
import Currency from '../../../shared_components/Currency/Currency';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { paymentFrequencyMap } from '../../../utils/currencyUtil';
import ShoppingBasketStatusPill from '../../ShoppingBasketPage/components/ShoppingBasketStatusPill';
import ShoppingBasketRemoveCoverable from '../../ShoppingBasketPage/components/ShoppingBasketRemoveCoverable';
import SpinOffMessage from '../../CheckoutPage/components/SpinOffMessage';
import { useHippoText } from '../../../hooks/useHippoText';
import { shouldHideName } from '../../ShoppingBasketPage/utils/ShoppingBasketUtil';
import { isLoggedOnSelector } from '../../../recoil/selectors/isLoggedOnSelector';
import { useRecoilValue } from 'recoil';
import { isAccCoverableForOtherPerson } from '../../../utils/coverablesUtil';

const ShoppingBasketSummaryCoverable = ({
    coverable,
    paymentFrequency,
    paymentFrequencyPostfix,
    shouldRenderOverlayDesign = false
}: {
    coverable: CoverableDTO;
    paymentFrequency: DSSPaymentFrequency;
    paymentFrequencyPostfix: string;
    shouldRenderOverlayDesign?: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const price =
        paymentFrequency === paymentFrequencyMap.monthly
            ? coverable.monthlyPrice?.amount ?? 0
            : coverable.yearlyPrice?.amount ?? 0;

    const isCalculated = !!price && price > 0;
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    return (
        <div className="coverable-item">
            <ListBox
                title={
                    shouldRenderOverlayDesign ? (
                        coverable.flavourName
                    ) : (
                        <h4>{coverable.flavourName}</h4>
                    )
                }
                subtitle={shouldHideName(coverable, isLoggedOn) ? '' : coverable.name}
                theme={'transparent'}
                infoArea={
                    <h6
                        className={
                            coverable.name
                                ? 'u-text-right'
                                : 'u-text-right u-spacing-stack-bottom-none'
                        }
                    >
                        <Currency price={price} paymentFrequencyPostfix={paymentFrequencyPostfix} />
                    </h6>
                }
            />
            {shouldRenderOverlayDesign && (
                <Grid className="u-spacing-stack-m u-display-flex u-flex-justify-between">
                    <GridItem>
                        {isCalculated && (
                            <ShoppingBasketStatusPill coverableStatus={'Calculated'} />
                        )}
                    </GridItem>
                    <GridItem
                        className="u-flex-box u-flex-box--center u-flex-box--gap-small"
                        colStart={12}
                    >
                        <ShoppingBasketRemoveCoverable coverable={coverable} displayOverlayText />
                    </GridItem>
                </Grid>
            )}
            {isAccCoverableForOtherPerson(coverable) ? (
                <SpinOffMessage
                    coverable={coverable}
                    message={getHippoText('DSS-SHOPPING-BASKET-OFFER-FOR-OTHER-LABEL', {
                        Coverable_name: coverable.name ?? ''
                    })}
                    showAccidentModal={true}
                />
            ) : (
                <SpinOffMessage
                    coverable={coverable}
                    title={getHippoText('DSS-SUMMARY-UW-HEADER')}
                    message={getHippoText('DSS-SUMMARY-UW-DESCRIPTION')}
                />
            )}
            <hr className="u-spacing-stack-top-5" />
        </div>
    );
};
export default ShoppingBasketSummaryCoverable;
